import { c as _c } from "react/compiler-runtime";
import { CurrencyDollarIcon, Trash02Icon } from '@systemeio/icons';
import { CurrencyEnum, PricePlanId, PricePlanType, PricePlanTypeEnum } from '@systemeio/types';
import { DeleteConfirmationLoader } from 'modules/digital-product/components/delete-confirmation-loader';
import { PillRadioGroup } from 'shared/components/pill-radio-group';
import { CreatePricePlanModal } from 'modules/digital-product/price-plans/components/create-price-plan-modal';
import { PricePlanDetails } from 'modules/digital-product/price-plans/components/price-plan-details';
import { usePricePlansApi } from 'modules/digital-product/price-plans/hooks/use-price-plans-api';
import { usePricePlansCount } from 'modules/digital-product/price-plans/hooks/use-price-plans-count';
import { useUserPricePlans } from 'modules/digital-product/price-plans/hooks/use-user-price-plans';
import { getPricePlansTypesData } from 'modules/digital-product/price-plans/utils/price-plans-utils';
import { IconTile } from 'shared/components/icon-tile';
import React, { useEffect, useState } from 'react';
import { Button, FormSelect, Hint, Modal, toast } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AttachPricePlanModalProps {
  currency: CurrencyEnum;
  /** Plans already attached to the product; they are filtered out of the list. */
  existingPricePlans: PricePlanType[];
  onClose: () => void;
  onSelect: (pricePlan: PricePlanType) => void;
  opened: boolean;
}
export function AttachPricePlanModal(t0) {
  const $ = _c(107);
  const {
    currency,
    existingPricePlans,
    onClose,
    onSelect,
    opened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    userPricePlans,
    mutateUserPricePlans
  } = useUserPricePlans(currency);
  const {
    deletePricePlan
  } = usePricePlansApi();
  const [type, setType] = useState();
  const [pricePlanId, setPricePlanId] = useState();
  const [isCreateOpened, setIsCreateOpened] = useState(false);
  const [pricePlanToDelete, setPricePlanToDelete] = useState(null);
  const {
    data: pricePlanUsage
  } = usePricePlansCount(!!pricePlanToDelete, pricePlanToDelete?.id);
  let t1;
  let t2;
  if ($[0] !== opened) {
    t1 = () => {
      if (!opened) {
        setType(undefined);
        setPricePlanId(undefined);
        setIsCreateOpened(false);
        setPricePlanToDelete(null);
      }
    };
    t2 = [opened];
    $[0] = opened;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let T0;
  let handleCreated;
  let handleDelete;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== deletePricePlan || $[4] !== existingPricePlans || $[5] !== isCreateOpened || $[6] !== mutateUserPricePlans || $[7] !== onClose || $[8] !== onSelect || $[9] !== opened || $[10] !== pricePlanId || $[11] !== pricePlanToDelete || $[12] !== t || $[13] !== type || $[14] !== userPricePlans) {
    const availablePricePlans = userPricePlans?.filter(pricePlan => pricePlan.type === type && !existingPricePlans.some(existing => existing.id === pricePlan.id));
    const selectedPricePlan = availablePricePlans?.find(pricePlan_0 => pricePlan_0.id === pricePlanId);
    const handleAdd = event => {
      event.preventDefault();
      if (!selectedPricePlan) {
        return;
      }
      onSelect(selectedPricePlan);
      onClose();
    };
    let t11;
    if ($[26] !== deletePricePlan || $[27] !== mutateUserPricePlans || $[28] !== pricePlanId || $[29] !== pricePlanToDelete || $[30] !== t) {
      t11 = async () => {
        if (!pricePlanToDelete) {
          return;
        }
        try {
          await deletePricePlan(pricePlanToDelete.id);
          await mutateUserPricePlans(data => data?.filter(el => el.id !== pricePlanToDelete.id), false);
          if (pricePlanToDelete.id === pricePlanId) {
            setPricePlanId(undefined);
          }
        } catch {
          toast.error(t("global.error"));
        }
      };
      $[26] = deletePricePlan;
      $[27] = mutateUserPricePlans;
      $[28] = pricePlanId;
      $[29] = pricePlanToDelete;
      $[30] = t;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    handleDelete = t11;
    let t12;
    if ($[32] !== onClose || $[33] !== onSelect) {
      t12 = pricePlan_1 => {
        onSelect(pricePlan_1);
        setIsCreateOpened(false);
        onClose();
      };
      $[32] = onClose;
      $[33] = onSelect;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    handleCreated = t12;
    T0 = Modal;
    t6 = opened && !isCreateOpened;
    t7 = onClose;
    let t13;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <IconTile size="m" tone="gray"><CurrencyDollarIcon /></IconTile>;
      $[35] = t13;
    } else {
      t13 = $[35];
    }
    let t14;
    if ($[36] !== t) {
      t14 = t("dashboard.digital_product.price_plans.header.title");
      $[36] = t;
      $[37] = t14;
    } else {
      t14 = $[37];
    }
    let t15;
    if ($[38] !== t14) {
      t15 = <span>{t14}</span>;
      $[38] = t14;
      $[39] = t15;
    } else {
      t15 = $[39];
    }
    let t16;
    if ($[40] !== t) {
      t16 = t("dashboard.digital_product.price_plans.header.description");
      $[40] = t;
      $[41] = t16;
    } else {
      t16 = $[41];
    }
    let t17;
    if ($[42] !== t16) {
      t17 = <span className="text-text-tertiary text-sm font-normal">{t16}</span>;
      $[42] = t16;
      $[43] = t17;
    } else {
      t17 = $[43];
    }
    if ($[44] !== t15 || $[45] !== t17) {
      t8 = <div className="flex items-center gap-4">{t13}<div className="flex flex-col">{t15}{t17}</div></div>;
      $[44] = t15;
      $[45] = t17;
      $[46] = t8;
    } else {
      t8 = $[46];
    }
    t9 = <form onSubmit={handleAdd} />;
    let t18;
    if ($[47] !== t) {
      t18 = t("global.cancel");
      $[47] = t;
      $[48] = t18;
    } else {
      t18 = $[48];
    }
    let t19;
    if ($[49] !== onClose || $[50] !== t18) {
      t19 = <Button type="button" className="tablet:flex-none flex-1" onClick={onClose} variant="secondary" size="md">{t18}</Button>;
      $[49] = onClose;
      $[50] = t18;
      $[51] = t19;
    } else {
      t19 = $[51];
    }
    const t20 = !selectedPricePlan;
    let t21;
    if ($[52] !== t) {
      t21 = t("dashboard.digital_product.price_plans.add_plan");
      $[52] = t;
      $[53] = t21;
    } else {
      t21 = $[53];
    }
    let t22;
    if ($[54] !== t20 || $[55] !== t21) {
      t22 = <Button disabled={t20} className="tablet:flex-none flex-1" type="submit" variant="primary" size="md">{t21}</Button>;
      $[54] = t20;
      $[55] = t21;
      $[56] = t22;
    } else {
      t22 = $[56];
    }
    if ($[57] !== t19 || $[58] !== t22) {
      t10 = <>{t19}{t22}</>;
      $[57] = t19;
      $[58] = t22;
      $[59] = t10;
    } else {
      t10 = $[59];
    }
    t3 = "flex flex-col gap-4";
    let t23;
    if ($[60] !== t) {
      t23 = t("dashboard.digital_product.price_plans.choose_type");
      $[60] = t;
      $[61] = t23;
    } else {
      t23 = $[61];
    }
    let t24;
    if ($[62] !== t23) {
      t24 = <span className="text-sm font-medium">{t23}</span>;
      $[62] = t23;
      $[63] = t24;
    } else {
      t24 = $[63];
    }
    let t25;
    if ($[64] !== t) {
      t25 = getPricePlansTypesData(t);
      $[64] = t;
      $[65] = t25;
    } else {
      t25 = $[65];
    }
    let t26;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = value => {
        setType(value);
        setPricePlanId(undefined);
      };
      $[66] = t26;
    } else {
      t26 = $[66];
    }
    let t27;
    if ($[67] !== t25 || $[68] !== type) {
      t27 = <PillRadioGroup options={t25} value={type} onChange={t26} />;
      $[67] = t25;
      $[68] = type;
      $[69] = t27;
    } else {
      t27 = $[69];
    }
    if ($[70] !== t24 || $[71] !== t27) {
      t4 = <div className="flex flex-col gap-2">{t24}{t27}</div>;
      $[70] = t24;
      $[71] = t27;
      $[72] = t4;
    } else {
      t4 = $[72];
    }
    t5 = type && <><FormSelect label={t("dashboard.digital_product.price_plans.choose_plan")} placeholder={t("global.select")} isPreFetching={!userPricePlans} data={availablePricePlans?.map(pricePlan_2 => ({
        id: pricePlan_2.id,
        caption: pricePlan_2.innerName,
        customCaption: <Hint ariaLabel={pricePlan_2.innerName} label={<PricePlanDetails pricePlan={pricePlan_2} variant="rows" />}><span className="truncate">{pricePlan_2.innerName}</span></Hint>,
        additionalRender: <Button aria-label={t("global.delete")} size="icon-sm" variant="destructive-ghost" onMouseDown={_temp} onClick={e_0 => {
          e_0.stopPropagation();
          setPricePlanToDelete(pricePlan_2);
        }}><Trash02Icon /></Button>
      }))} value={pricePlanId} onChange={setPricePlanId} />{selectedPricePlan && <PricePlanDetails className="border-border-200 text-text-tertiary flex-1 rounded-xl border px-4 py-3.5" pricePlan={selectedPricePlan} />}<div className="text-text-primary flex flex-wrap items-center gap-2"><span>{t("dashboard.funnel.configuration.offer.add_price_plan_footer")}</span><Button type="button" variant="link" onClick={() => setIsCreateOpened(true)}>{t("dashboard.funnel.configuration.offer.add_price_plan_footer_link")}</Button></div></>;
    $[3] = deletePricePlan;
    $[4] = existingPricePlans;
    $[5] = isCreateOpened;
    $[6] = mutateUserPricePlans;
    $[7] = onClose;
    $[8] = onSelect;
    $[9] = opened;
    $[10] = pricePlanId;
    $[11] = pricePlanToDelete;
    $[12] = t;
    $[13] = type;
    $[14] = userPricePlans;
    $[15] = T0;
    $[16] = handleCreated;
    $[17] = handleDelete;
    $[18] = t10;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    T0 = $[15];
    handleCreated = $[16];
    handleDelete = $[17];
    t10 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t11;
  if ($[73] !== t3 || $[74] !== t4 || $[75] !== t5) {
    t11 = <div className={t3}>{t4}{t5}</div>;
    $[73] = t3;
    $[74] = t4;
    $[75] = t5;
    $[76] = t11;
  } else {
    t11 = $[76];
  }
  let t12;
  if ($[77] !== T0 || $[78] !== t10 || $[79] !== t11 || $[80] !== t6 || $[81] !== t7 || $[82] !== t8 || $[83] !== t9) {
    t12 = <T0 opened={t6} onClose={t7} title={t8} render={t9} footer={t10}>{t11}</T0>;
    $[77] = T0;
    $[78] = t10;
    $[79] = t11;
    $[80] = t6;
    $[81] = t7;
    $[82] = t8;
    $[83] = t9;
    $[84] = t12;
  } else {
    t12 = $[84];
  }
  const t13 = !!pricePlanToDelete;
  let t14;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setPricePlanToDelete(null);
    $[85] = t14;
  } else {
    t14 = $[85];
  }
  let t15;
  if ($[86] !== pricePlanToDelete?.innerName || $[87] !== pricePlanUsage || $[88] !== t) {
    t15 = pricePlanUsage ? <div className="text-text-primary text-base">{t("dashboard.offer.digital_product.price_plans.remove_description_with_count", {
        pricePlanName: pricePlanToDelete?.innerName,
        numberOfSteps: pricePlanUsage.count
      })}</div> : <DeleteConfirmationLoader />;
    $[86] = pricePlanToDelete?.innerName;
    $[87] = pricePlanUsage;
    $[88] = t;
    $[89] = t15;
  } else {
    t15 = $[89];
  }
  let t16;
  if ($[90] !== handleDelete || $[91] !== t13 || $[92] !== t15) {
    t16 = <Confirmation status="error" opened={t13} onClose={t14} onConfirm={handleDelete} confirmationContent={t15} />;
    $[90] = handleDelete;
    $[91] = t13;
    $[92] = t15;
    $[93] = t16;
  } else {
    t16 = $[93];
  }
  const t17 = opened && isCreateOpened;
  let t18;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setIsCreateOpened(false);
    $[94] = t18;
  } else {
    t18 = $[94];
  }
  let t19;
  if ($[95] !== onClose) {
    t19 = () => {
      setIsCreateOpened(false);
      onClose();
    };
    $[95] = onClose;
    $[96] = t19;
  } else {
    t19 = $[96];
  }
  let t20;
  if ($[97] !== currency || $[98] !== handleCreated || $[99] !== t17 || $[100] !== t19 || $[101] !== type) {
    t20 = <CreatePricePlanModal opened={t17} currency={currency} initialType={type} onBack={t18} onClose={t19} onCreated={handleCreated} />;
    $[97] = currency;
    $[98] = handleCreated;
    $[99] = t17;
    $[100] = t19;
    $[101] = type;
    $[102] = t20;
  } else {
    t20 = $[102];
  }
  let t21;
  if ($[103] !== t12 || $[104] !== t16 || $[105] !== t20) {
    t21 = <>{t12}{t16}{t20}</>;
    $[103] = t12;
    $[104] = t16;
    $[105] = t20;
    $[106] = t21;
  } else {
    t21 = $[106];
  }
  return t21;
}
function _temp(e) {
  return e.stopPropagation();
}